import type {OverallStatsDataParams, PublicStatsDataParams} from './types';
import type {ValueEditorBindings} from 'shared/value-editors/kp-value-editor/types';
import type {EditedProperty} from 'typings/portaro.be.types';

// Plugin for ChartJS adding bottom margin to chart legend
export const legendMarginChartJSPlugin = {
    id: 'legendMargin',
    afterInit(chart: any, args: any, plugins: any) {
        const originalFit = chart.legend.fit;
        const margin = plugins.margin || 0;
        chart.legend.fit = function fit() {
            if (originalFit) {
                originalFit.call(this);
            }

            return this.height += margin;
        }
    }
};

export function findEditorBindingsInFields(fields: EditedProperty[], fieldName: string): ValueEditorBindings | null {
    return fields.find((field) => field.fieldName === fieldName)?.editor ?? null;
}

export function findEditorLabelInFields(fields: EditedProperty[], fieldName: string): string {
    return fields.find((field) => field.fieldName === fieldName)?.label ?? '';
}

export function filterPublicStatsParams(publicParams: PublicStatsDataParams): PublicStatsDataParams {
    const {fromDate, toDate, timeGranularity} = publicParams;
    return {fromDate, toDate, timeGranularity};
}

export function filterOverallStatsParams(overallParams: OverallStatsDataParams): OverallStatsDataParams {
    const {fromDate, toDate, department, location} = overallParams;
    return {fromDate, toDate, department, location: location ?? []};
}